import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openDataPlatformSubmenu } from '../sidebarHelpers';

const exploreSegment = (baseUrl, navigate, segment, user) => {
  return {
    id: 'exploreSegment',
    title: 'Explore a segment "Sent email from campaign or workflow"',
    steps: [
      {
        selector: '[data-tour="dataPlatformLink"]',
        content: <p>Click on the "Data Platform" menu item in the navigation.</p>,
      },
      {
        actionBefore: () => openDataPlatformSubmenu('[data-tour="segmentsLink"]'),
        selector: '[data-tour="segmentsLink"]',
        content: (
          <>
            <p>
              The Segment is a cohort of users grouped by one or multiple criteria. We have already created some for
              your convenience but you can also create your own segments.
            </p>
            <p>Click on the "Segments" in the navigation</p>
          </>
        ),
      },
      {
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/segments`, true);
        },
        selector: '[data-segment-name="Sent email from campaign or workflow"]',
        content: (
          <p>
            This segment allows you to see to how many users a particular campaign was sent to in the last 7 days and
            how many of them made a purchase in that interval.
          </p>
        ),
      },
      {
        selector: '[data-segment-name="Sent email from campaign or workflow"] a',
        content: <p>Click on the segment name to open the segment settings</p>,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/segments/${segment.id}`, true),
        selector: '[data-tour="segmentPageRules"]',
        content: (
          <p>
            Each segment can be created by applying one or more rules. These rules can relate to product features,
            customer behavior, or other events. This segment is created by applying the rules Sent email and Purchased.
          </p>
        ),
      },
      {
        selector: '[data-tour="segmentPageFilters"]',
        content: <p>Each rule has a number of filters that you can apply separately or together.</p>,
        actionBefore: async () => {
          // Click the first collapsed rule to expand it
          const expandButton = document.querySelector('[data-rule-name] button[aria-expanded="false"]');
          if (expandButton) {
            expandButton.click();
          }
          // Wait for collapse animation to complete
          await new Promise((resolve) => setTimeout(resolve, 800));
        },
      },
      {
        selector: '[data-rule-name="Sent email"]',
        content: (
          <p>
            This is the Sent email rule. Each rule is binary - it can either be a sent or not sent the email.
          </p>
        ),
      },
      {
        selector: '[data-tour="segmentSelectedFilterElements"]',
        content: (
          <p>
            There can be multiple filters applied to each rule. With each filter, you narrow down the number of users in
            your segment. The filters here are showing you what users have been sent the Abandoned cart email in the
            last 7 days.
          </p>
        ),
      },
      {
        selector: '[data-rule-name="Purchased"]',
        content: <p>This is the "Purchased" rule.</p>,
        actionBefore: async () => {
          // Click the Purchased rule header button to expand it
          const ruleButton = document.querySelector('[data-rule-name="Purchased"] button[aria-expanded]');
          if (ruleButton) {
            ruleButton.click();
          }
          await new Promise((resolve) => setTimeout(resolve, 800));
        },
      },
      {
        selector: '[data-rule-name="Purchased"] [data-tour="segmentSelectedFilterElements"]',
        content: (
          <p>
            This filter will bring out all the users who fall under the upper rule and have made a purchase in the last
            7 days.
          </p>
        ),
        actionBefore: async () => {
          // Ensure the Purchased rule is expanded
          const expandButton = document.querySelector('[data-rule-name="Purchased"] button[aria-expanded="false"]');
          if (expandButton) {
            expandButton.click();
          }
          await new Promise((resolve) => setTimeout(resolve, 800));
        },
      },
      {
        selector: '[data-tour="segmentEstimatedProfiles"]',
        content: (
          <>
            <p>This is an estimate of the number of users that fall under both of the above rules.</p>
            <p>It is possible that currently there are no users.</p>
            <p>
              When in use each segment is calculated every hour according to the rules you selected. Each time a segment
              is calculated users is added or removed accordingly.
            </p>
          </>
        ),
      },
      {
        actionBefore: () => navigate(`${baseUrl}/guide`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: !!user.userActions.find((a) => a.action === 'taskCompleted' && a.context.task === 'exploreSegment'),
  };
};

export default exploreSegment;
